'use strict';
exports.test = function () {
  return typeof global.queueMicrotask === 'function';
};

exports.install = function (func) {
  return function () {
    global.queueMicrotask(func);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/immediate/lib/queueMicrotask.js
// module id = 724
// module chunks = 7